import { useState, useEffect } from 'react';
import { MasterDataApi } from '@shared/apis';
import { MasterData } from '@shared/types/publication';
import { MasterDataResponse } from '@shared/types/master-data';

interface UseMasterDataResult {
    categories: MasterData[],
    isLoading: boolean,
    error: string | null,
    refetch: () => void
}

const useMasterData = (): UseMasterDataResult => {
    const [categories, setCategories] = useState<MasterData[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchMasterData = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await MasterDataApi.getAll();
            const data: MasterDataResponse = response.data?.data || {};

            const allCategory: MasterData = {
                id: 'all',
                label: 'すべて',
                code: 'all'
            };

            setCategories([allCategory, ...(data.category || [])]);
        } catch (err) {
            setError('Failed to fetch master data');
            console.error('Error fetching master data:', err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchMasterData();
    }, []);

    return {
        categories,
        isLoading,
        error,
        refetch: fetchMasterData
    };
};

export default useMasterData;
